define('views/modules/setting/setting-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/setting/business/business-content',
    'views/modules/setting/personal/personal-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VBusinessContent,
    VPersonalContent
) {

    var VSettingPanel = VBasePanel.extend({
        header: {
            title: "Settings",
            subtitle: "Customize your own Totalcoaching",
        },

        tabs: [
            { id: 'business', title: 'Business', callback: 'showBusiness', active: true },
            { id: 'personal', title: 'Personal', callback: 'showPersonal' }
        ],
        content: {
            business: VBusinessContent,
            personal: VPersonalContent,
        },
        defaultView: 'business',

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model
            }, this.options);
        },

        showPersonal: function() { this.showContent('personal'); },
        showBusiness: function() { this.showContent('business'); },

    });

    return VSettingPanel;

});

